(function () {
  if (window.__drInit) return;
  window.__drInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals(root) {
    var els = (root || document).querySelectorAll('.dr-reveal:not([data-dr-init])');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('dr-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('dr-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { el.dataset.drInit = '1'; io.observe(el); });
  }

  function initManifesto(root) {
    (root || document).querySelectorAll('[data-dr-manifesto]:not([data-dr-init])').forEach(function (el) {
      el.dataset.drInit = '1';
      var words = el.querySelectorAll('.dr-word');
      if (reduce) { words.forEach(function (w) { w.classList.add('dr-on'); }); return; }
      function update() {
        var r = el.getBoundingClientRect();
        var vh = window.innerHeight;
        var p = Math.min(1, Math.max(0, (vh * 0.85 - r.top) / (r.height + vh * 0.35)));
        var n = Math.round(p * words.length);
        words.forEach(function (w, i) { w.classList.toggle('dr-on', i < n); });
      }
      window.addEventListener('scroll', update, { passive: true });
      update();
    });
  }

  function initFaq(root) {
    (root || document).querySelectorAll('[data-dr-faq] .dr-faq__q:not([data-dr-init])').forEach(function (btn) {
      btn.dataset.drInit = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('.dr-faq__item');
        var open = item.classList.toggle('dr-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function initMagnetic(root) {
    if (reduce) return;
    (root || document).querySelectorAll('[data-dr-magnetic]:not([data-dr-init])').forEach(function (b) {
      b.dataset.drInit = '1';
      b.addEventListener('mousemove', function (e) {
        var r = b.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) / r.width;
        var y = (e.clientY - r.top - r.height / 2) / r.height;
        b.style.transform = 'translate(' + (x * 8) + 'px,' + (y * 8) + 'px)';
      });
      b.addEventListener('mouseleave', function () { b.style.transform = ''; });
    });
  }

  function initAll(root) { initReveals(root); initManifesto(root); initFaq(root); initMagnetic(root); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
